import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type { NoteInfoProps } from './schema';

export default createStore('timeStreamAssetNoteStore', {
    notes: new ObservableMap<string, NoteInfoProps>(), // key is the remoteId
});
